export default ((props, keepData)=>{
    const { endpoint, callCodelistAPICredentials, callCodelistApiRemoteDataConverter, name, parentFilter, codelistContext, parentFilterUrlParam, searchTextUrlParam } = props;
    return {
        endpoint,
        callCodelistAPICredentials,
        callCodelistApiRemoteDataConverter,
        name,
        parentFilter,
        codelistContext,
        parentFilterUrlParam,
        searchTextUrlParam,
        keepData: !!keepData
    };
});
